module.exports = __webpack_public_path__ + "static/img/__8893.a14b9f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8893.jpg
// module id = wVBo
// module chunks = 0